export default "__VITE_ASSET__BZD$jqxC__"